import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    menu: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s4,
      minWidth: 200,
      padding: [Spacings.s8, Spacings.s8],
    },
    sheetHeading: {
      padding: [Spacings.s0, Spacings.s16, Spacings.s8, Spacings.s16],
    },
  },
  { name: 'upload-source-menu' }
);

export default useStyles;
